exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-input-bor[data-v-06e63bc4] {\n    border: 1px solid #e7e7e7;\n    border-radius: 4px;\n    padding: 5px;\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n.custom-input-bor.active[data-v-06e63bc4] {\n    border: 1px solid #20bf64;\n}\n.custom-input[data-v-06e63bc4] {\n    border: none;\n    outline: none;\n    width: 100%;\n    color: #585859;\n    height: 100%;\n}\n.custom-input[data-v-06e63bc4]::placeholder {\n    color: #999999;\n}\n.unit[data-v-06e63bc4] {\n    position: absolute;\n    right: 5px;\n    line-height: 2;\n    /* width: 20px; */\n    background: #fff;\n    /* padding-left: 5px; */\n    height: 100%;\n}\n.error[data-v-06e63bc4] {\n    border: 1px solid red;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06e63bc4","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/CustomInput.vue
// module id = KSeg
// module chunks = 142